import { defineStore } from 'pinia';
import { useControlLayerStore } from '@/store-pinia/control-layer';

export const useRouterStore = defineStore('router', {
  state: () => ({
    routes: [],
    currentRoute: null
  }),
  getters: {
    routeComponents() {
      return this.routes.reduce(
        (prev, element) => ({
          ...prev,
          [element.component.name]: element.component
        }),
        {}
      );
    },
    routeNames() {
      return this.routes.reduce(
        (prev, element) => ({ ...prev, [element.name]: element }),
        {}
      );
    },
    routeDefinition(state) {
      if (
        !Object.prototype.hasOwnProperty.call(
          state.routeNames,
          state.currentRoute
        )
      ) {
        return null;
      }
      return state.routeNames[state.currentRoute];
    },
    routeComponent(state) {
      if (null === state.routeDefinition) {
        return null;
      }
      return state.routeDefinition.component.name;
    },
    routeProps(/** state **/) {
      const controlLayerStore = useControlLayerStore();
      return {
        activeElement: controlLayerStore.activeElement
      };
      // @todo we need to check the mixin for props as well, so we just return all props always for now.
      // if (
      //   null === state.routeDefinition ||
      //   !Object.prototype.hasOwnProperty.call(
      //     state.routeDefinition.component,
      //     'props'
      //   )
      // ) {
      //   return {};
      // }
      //
      // const props = {};
      // const controlLayerStore = useControlLayerStore();
      // Object.keys(state.routeDefinition.component.props).forEach(prop => {
      //   switch (prop) {
      //     case 'activeElement':
      //       props.activeElement = controlLayerStore.activeElement;
      //       return;
      //   }
      // });
      // return props;
    }
  },
  actions: {}
});
